export default {
  init() {

    let d = new Date();
    let offSet = d.getTimezoneOffset() * 60000;

    let currentMonth = new Date(d.getFullYear(), d.getMonth(), 1);

    let endOfMonth = new Date(currentMonth.getFullYear(), currentMonth.getMonth() + 1, 0);
    endOfMonth = endOfMonth.getTime() - offSet;
    currentMonth = currentMonth.getTime() - offSet;

    $(".governing-authority-calendar-list li").each(function() {
      var theDate = parseInt($(this).attr("data-date"));

      if(theDate >= currentMonth && theDate < endOfMonth) {
        $(this).show();
      } else {
        $(this).hide();
      }
    });


  },
  finalize() {
    let calendar = "";
    let events = governingAuthorityCalendarDatesAll;
    let type = 'governing-authority'

    var newSchoolsArray = governingAuthorityCalendarDatesAll.filter(function (el) {
      if (el.school.includes(type)) {
        return el
      }
    });

    function createCalendar(events) {
      var calendarEl = document.getElementById('calendar');

      var d = new Date();
      var month = d.getMonth() + 1;
      if(month < 10) {
        month = 0 + month.toString();
      }

      let initialDate = d.getFullYear()+"-"+month+"-01";

      calendar = new FullCalendar.Calendar(calendarEl, {
        themeSystem: 'bootstrap',
        height: 650,
        initialView: 'dayGridMonth',
        initialDate: initialDate,
        dayMaxEvents: 1,
        customButtons: {
          myCustomNextButton: {
            text: 'Next',
            icon: 'fa-chevron-right',
            click: function() {
              calendar.next();
              changeMonth(calendar);
            }
          },
          myCustomPrevButton: {
            text: 'Prev',
            icon: 'fa-chevron-left',
            click: function() {
              calendar.prev();
              changeMonth(calendar);
            }
          }
        },
        headerToolbar: {
          left: 'myCustomPrevButton',
          center: 'title',
          right: 'myCustomNextButton'
        },
        events: events,

      });

      calendar.render();
    }

    createCalendar(newSchoolsArray);

    $("#school").on("change", function(e) {
      e.preventDefault();
      let school = $(this).find(":selected").val();

      let events = governingAuthorityCalendarDatesAll;
      type = school;

      var newSchoolsArray = governingAuthorityCalendarDatesAll.filter(function (el) {
        if (el.school.includes(type)) {
          return el
        }
      });

      createCalendar(newSchoolsArray);


      let d = new Date();
      let offSet = d.getTimezoneOffset() * 60000;

      let currentMonth = calendar.getDate();

      let endOfMonth = new Date(currentMonth.getFullYear(), currentMonth.getMonth() + 1, 0);
      endOfMonth = endOfMonth.getTime() - offSet;
      currentMonth = currentMonth.getTime() - offSet;

      $(".governing-authority-calendar-list li").each(function() {
        var schools = $(this).attr("data-school");
        schools = JSON.parse(schools);

        var theDate = parseInt($(this).attr("data-date"));
        if(schools.includes(type) && (theDate >= currentMonth && theDate < endOfMonth)) {
          $(this).show();
        } else {
          $(this).hide();
        }
      });
    });

    function changeMonth(calendar) {

      let d = new Date();
      let offSet = d.getTimezoneOffset() * 60000;

      let currentMonth = calendar.getDate();

      let endOfMonth = new Date(currentMonth.getFullYear(), currentMonth.getMonth() + 1, 0);
      endOfMonth = endOfMonth.getTime() - offSet;
      currentMonth = currentMonth.getTime() - offSet;

      $(".governing-authority-calendar-list li").each(function() {
        var theDate = parseInt($(this).attr("data-date"));
        var schools = $(this).attr("data-school");
        schools = JSON.parse(schools);

        if(schools.includes(type) && (theDate >= currentMonth && theDate < endOfMonth)) {
          $(this).show();
        } else {
          $(this).hide();
        }
      });
    }

  },
};



// WEBPACK FOOTER //
// ./scripts/routes/templateGoverningAuthority.js